let html = `<div class="extensions-info">
    <div class="extensions-info__descr"></div>
    <div class="extensions-info__instruction"></div>

    <div class="extensions-info__footer"> </div>
</div>`

export default html